export const isEmail = (mail: string): boolean => {
  return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail);
};

export const isString = function (candidate: string): boolean {
  return !!(candidate && /^[\p{L}'][ \p{L}'-]*\p{L}$/u.test(candidate));
};